// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';

interface SetPrefixOrSuffixParams {
  fieldId: string;
  changeType: 'prefix' | 'suffix';
  newValue: string;
}

export function setFieldSettingsPrefixOrSuffixField(
  ydb: Database,
  { fieldId, changeType, newValue }: SetPrefixOrSuffixParams
): void {
  ydb.mutate((db) => {
    if (changeType === 'prefix') {
      db.fieldsById[fieldId].customNumberFormat.prefix = newValue;
    } else if (changeType === 'suffix') {
      db.fieldsById[fieldId].customNumberFormat.suffix = newValue;
    }
  });
}
